import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreateCampaignTemplateRoutingModule } from './create-campaign-template-routing.module';
import { CreateCampaignTemplateComponent } from './create-campaign-template.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from 'src/app/shared/shared.module';
import { WhatsappcontactModule } from '../whatsappcontact/whatsappcontact.module';
import { WhatsappVideoModule } from '../whatsappResource/whatsapp-video/whatsapp-video.module';
import { HomepageModule } from '../../system/homepage/homepage.module';
import { TemplateScreenModule } from '../template-screen/template-screen.module';
import { WhatsappImageModule } from '../../whatsapp-image/whatsapp-image.module';
import { WhatsappPdfModule } from '../whatsappResource/whatsapp-pdf/whatsapp-pdf.module';
import { WhatsappAudioModule } from '../whatsappResource/whatsapp-audio/whatsapp-audio.module';
import { WhatsappImagesModule } from '../whatsappResource/whatsapp-images/whatsapp-images.module';
import { MatExpansionModule } from '@angular/material/expansion';


@NgModule({
  declarations: [
    CreateCampaignTemplateComponent
  ],
  imports: [
    CommonModule,
    CreateCampaignTemplateRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    CustomFlexLayoutModule,
    MatButtonModule,
    MatOptionModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    SharedModule,
    WhatsappVideoModule,
    HomepageModule,
    WhatsappImageModule,
    WhatsappPdfModule,
    WhatsappImagesModule,
    WhatsappAudioModule,
    MatExpansionModule
  ],exports:[
    CreateCampaignTemplateComponent
  ]
})
export class CreateCampaignTemplateModule { }
